import { Route } from "@mui/icons-material";
import React from "react";
import { PlaneacionEstrategicaScreen } from "./PlaneacionEstrategicaScreen";

export const PlaneacionEstrategicaMain = () => {
  return (
    <div className="main-container">
      <Route path="/PlaneacionEstrategica/Main" component={() => <PlaneacionEstrategicaScreen />} />
    </div>
  );
};
